/**
 * Parses an ISO datetime string and returns a Date representing
 * the local time components in UTC. This avoids relying on
 * Intl.DateTimeFormat's timeZone support, which some mobile
 * in-app browsers handle incorrectly (falling back to the device
 * timezone instead of the specified facility timezone).
 *
 * Example: "2026-03-29T07:30:00+10:00" → Date(UTC 2026-03-29T07:30:00Z)
 * When formatted with timeZone: "UTC", this displays "07:30" — the
 * correct facility-local time regardless of the device's timezone.
 */
export function toLocalDateAsUTC(isoString: string): Date {
  const m = isoString.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?/,
  );
  if (!m) return new Date(isoString);
  return new Date(
    Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6], +(m[7] ?? 0)),
  );
}
